import * as React from "react"

const IconInfoMessage = (props) => (
  <svg
    width={20}
    height={22}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 18.883a6.883 6.883 0 1 0 0-13.766 6.883 6.883 0 0 0 0 13.766Zm1.904-3.934a.632.632 0 0 1-.448.183.632.632 0 0 1-.448-.183l-1.874-1.874a.632.632 0 0 1-.183-.448V8.248c0-.346.285-.631.63-.631.347 0 .632.285.632.631v4.114l1.69 1.69a.681.681 0 0 1 0 .897Z"
      fill="#141938"
    />
  </svg>
)

export default IconInfoMessage